import type { Template } from "@/types";

export const LA_05_H4_V1: Template[] = [
    {
        id: "la-05-h4v1-01",
        name: "LA 01 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 67, y: 80, width: 542, height: 372, rotation: 0, imageRotation: 0 },
            { id: "2", x: 796, y: 80, width: 171, height: 119, rotation: 0, imageRotation: 0 },
            { id: "3", x: 796, y: 207, width: 171, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 796, y: 333, width: 171, height: 118, rotation: 0, imageRotation: 0 },
            { id: "5", x: 975, y: 80, width: 258, height: 372, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-02",
        name: "LA 02 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 65, y: 66, width: 269, height: 200, rotation: 0, imageRotation: 0 },
            { id: "2", x: 65, y: 275, width: 269, height: 200, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 66, width: 269, height: 200, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 275, width: 269, height: 200, rotation: 0, imageRotation: 0 },
            { id: "5", x: 871, y: 66, width: 286, height: 409, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-03",
        name: "LA 03 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 123, y: 83, width: 258, height: 179, rotation: 0, imageRotation: 0 },
            { id: "2", x: 123, y: 270, width: 258, height: 179, rotation: 0, imageRotation: 0 },
            { id: "3", x: 478, y: 0, width: 396, height: 531, rotation: 0, imageRotation: 0 },
            { id: "4", x: 971, y: 83, width: 258, height: 179, rotation: 0, imageRotation: 0 },
            { id: "5", x: 971, y: 270, width: 258, height: 179, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-04",
        name: "LA 04 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 177, width: 236, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 244, y: 177, width: 236, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 488, y: 0, width: 376, height: 531, rotation: 0, imageRotation: 0 },
            { id: "4", x: 872, y: 177, width: 236, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1116, y: 177, width: 236, height: 178, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-05",
        name: "LA 05 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 237, y: 44, width: 204, height: 141, rotation: 0, imageRotation: 0 },
            { id: "2", x: 237, y: 345, width: 204, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 873, y: 44, width: 282, height: 442, rotation: 0, imageRotation: 0 },
            { id: "4", x: 131, y: 194, width: 205, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 344, y: 194, width: 204, height: 141, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-06",
        name: "LA 06 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 109, y: 52, width: 457, height: 321, rotation: 0, imageRotation: 0 },
            { id: "2", x: 109, y: 381, width: 147, height: 101, rotation: 0, imageRotation: 0 },
            { id: "3", x: 264, y: 381, width: 147, height: 101, rotation: 0, imageRotation: 0 },
            { id: "4", x: 419, y: 381, width: 147, height: 101, rotation: 0, imageRotation: 0 },
            { id: "5", x: 862, y: 52, width: 304, height: 430, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-07",
        name: "LA 07 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 201, y: 37, width: 301, height: 226, rotation: 0, imageRotation: 0 },
            { id: "2", x: 201, y: 271, width: 301, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 510, y: 37, width: 332, height: 457, rotation: 0, imageRotation: 0 },
            { id: "4", x: 850, y: 37, width: 301, height: 226, rotation: 0, imageRotation: 0 },
            { id: "5", x: 850, y: 271, width: 301, height: 224, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-08",
        name: "LA 08 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 46, y: 55, width: 581, height: 421, rotation: 0, imageRotation: 0 },
            { id: "2", x: 635, y: 55, width: 401, height: 270, rotation: 0, imageRotation: 0 },
            { id: "3", x: 635, y: 333, width: 197, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 840, y: 333, width: 196, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1044, y: 55, width: 264, height: 421, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-09",
        name: "LA 09 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 46, y: 55, width: 400, height: 270, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 333, width: 196, height: 143, rotation: 0, imageRotation: 0 },
            { id: "3", x: 250, y: 333, width: 196, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 454, y: 55, width: 580, height: 421, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1042, y: 55, width: 264, height: 421, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h4v1-10",
        name: "LA 10 - H4V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-05-h4_v1_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 46, y: 55, width: 264, height: 421, rotation: 0, imageRotation: 0 },
            { id: "2", x: 318, y: 55, width: 580, height: 421, rotation: 0, imageRotation: 0 },
            { id: "3", x: 906, y: 208, width: 400, height: 268, rotation: 0, imageRotation: 0 },
            { id: "4", x: 906, y: 55, width: 196, height: 144, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1110, y: 55, width: 196, height: 144, rotation: 0, imageRotation: 0 }
        ],
    }
];